import {TableColumnDefinition} from '@ft/core';

export const FILES_COLUMNS: TableColumnDefinition[] = [
  {
    'label': 'shared.date',
    'key': 'created_at',
    'sortBy': 'created_at',
    'type': 'text',
    'is_global_searchable': true
  } ,
  {
    'label': 'shared.type',
    'key': 'mime',
    'sortBy': 'mime',
    'type': 'text',
    'is_global_searchable': true
  },
  {
    'label': 'shared.title',
    'key': 'name',
    'sortBy': 'name',
    'type': 'text',
    'is_global_searchable': true
  }
];
